import { useEffect } from 'react';
import styles from './MeetingFrameLeft.module.css';

/**
 * MeetingFrameLeft — destino de `leaveUrl` del Meeting SDK dentro del iframe.
 * Cuando el usuario sale/termina la reunión, el SDK navega el iframe hasta
 * acá; avisamos al padre (ZoomFloat) por postMessage para que cierre la
 * ventana flotante — mismo efecto que `onReadyToClose` en JitsiFloat, que el
 * SDK de Zoom no ofrece directamente.
 */
export default function MeetingFrameLeft() {
  useEffect(() => {
    window.parent.postMessage({ type: 'eventify-zoom-left' }, window.location.origin);
  }, []);

  return (
    <div className={styles.pantalla}>
      Reunión finalizada.
    </div>
  );
}
